<app-batch-item
    [initialTask]="params?.Job"
    [showCloseButton]="true"
    (onClose)="closeModal()"
></app-batch-item>
